<script lang="ts">
  import Button from "../input/Button.svelte";

  let {
    open = $bindable(false),
    title = "확인",
    message = "",
    confirmLabel = "확인",
    cancelLabel = "취소",
    variant = "danger",
    onconfirm,
    oncancel,
  }: {
    open?: boolean;
    title?: string;
    message?: string;
    confirmLabel?: string;
    cancelLabel?: string;
    variant?: "danger" | "warning" | "info";
    onconfirm?: () => void;
    oncancel?: () => void;
  } = $props();

  const variantBtn: Record<string, "danger" | "primary" | "secondary"> = {
    danger: "danger",
    warning: "primary",
    info: "primary",
  };

  function confirm() {
    open = false;
    onconfirm?.();
  }

  function cancel() {
    open = false;
    oncancel?.();
  }
</script>

{#if open}
  <div
    class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
    role="dialog"
    aria-modal="true"
    aria-labelledby="confirm-title"
  >
    <div class="w-full max-w-sm rounded-2xl border border-white/10 bg-slate-900 p-6 shadow-2xl">
      <h2 id="confirm-title" class="text-base font-semibold text-white mb-2">{title}</h2>
      {#if message}
        <p class="text-sm text-gray-400 mb-5">{message}</p>
      {/if}
      <div class="flex gap-2 justify-end">
        <Button variant="secondary" size="sm" onclick={cancel}>{cancelLabel}</Button>
        <Button variant={variantBtn[variant]} size="sm" onclick={confirm}>{confirmLabel}</Button>
      </div>
    </div>
  </div>
{/if}
